import { createFieldControl } from './createFieldControl.ts';

export const textareaVariants = createFieldControl(
  'flex min-h-[var(--component-height-4xl,120px)]'
);
